import { render, staticRenderFns } from "./NewAlert.vue?vue&type=template&id=af008bf2&"
import script from "./NewAlert.vue?vue&type=script&lang=js&"
export * from "./NewAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports